import { connect } from 'react-redux';
import Table from './ApplicationTable';
import React, { createContext, useContext, useState, useEffect, useCallback } from "react"
// import { CSVLink, CSVDownload } from "react-csv";
import Button from '@mui/material/Button';
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
// import LocalizationProvider from '@mui/lab/LocalizationProvider';
import Grid from '@mui/material/Grid';
import moment from 'moment';
import Accordion from '@mui/material/Accordion';
import AccordionActions from '@mui/material/AccordionActions';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
// import DateFnsUtils from '@date-io/date-fns';
import DateFnsUtils from '@mui/lab/AdapterDateFns';
import ja from "date-fns/locale/ja";
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import PropTypes from 'prop-types';
import { Authentication } from '../../App'
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import { DialogActions, DialogContent } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { purple, red, grey } from '@mui/material/colors';
import {
    useParams,
  } from 'react-router-dom';
import InputAdornment from '@mui/material/InputAdornment';
import { NumericFormat } from 'react-number-format';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import Checkbox from '@mui/material/Checkbox';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import RadioGroup from '@mui/material/RadioGroup';
import Radio from '@mui/material/Radio';
import Timeline from '@mui/lab/Timeline';
import TimelineItem from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineDot from '@mui/lab/TimelineDot';
import FormLabel from '@mui/material/FormLabel';
import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';

//フォームを開く　PM業務登録
const FormDetails = (props) => {
    //1個めのselect option
    const Option1 = ["-","管理運営業務費","管理員業務費","日常清掃費","定期清掃費","一般ゴミ回収","残置ゴミ回収","公共料金","共用部分 水道代","共用部分 電気代","水道検針業務","建築･設備管理業務費","給水ポンプ点検費","排水ポンプ点検費","受水槽清掃費","雑排水管清掃費","消防設備点検費","エレベーター保守費","浄化槽点検費","機械監視等","防犯カメラ関係","PMサポート業務費","24時間システム料","定期巡回費"]
    const Option2 = ["","当社受注","オーナー手配","オーナー代行"]
    const Option3 = ["","スポット","分割","毎月","立替","一括","負担","点検後支払","オーナー手配","無し"]
    
    const [formData, setFormData] = useState([""]);
    const handleChange = (index) => (e) => {
        const newValue = e.target.value;
        setFormData((prev) => {
          const updatedData = [...prev];
          while (updatedData.length < 14) {
            updatedData.push("");
          }
          updatedData[index] = newValue;
          return updatedData;
        });
    };
    useEffect(()=>{
        let stringData = formData
        stringData = stringData.join(',')
        props.changeDetail(stringData,props.key)
    },[formData])
    
      return (
        <Box sx={{ display: 'grid', gap: 2, gridTemplateColumns: 'repeat(2, 1fr)' }}>
          
          <FormControl fullWidth>
            <InputLabel id="payment-label"></InputLabel>
            <Select
              labelId="payment-label"
              value={formData[0] || ""}
              onChange={handleChange(0)}
            >
                {Option1.map((option)=><MenuItem value={option}>{option}</MenuItem>)}
            </Select>
          </FormControl>
          
          <FormControl fullWidth>
            <InputLabel id="payment-label"></InputLabel>
            <Select
              labelId="payment-label"
              value={formData[1] || ""}
              onChange={handleChange(1)}
            >
                {Option2.map((option)=><MenuItem value={option}>{option}</MenuItem>)}
            </Select>
          </FormControl>
          <TextField
            label="売価(月額)"
            value={formData[2] || ""}
            onChange={handleChange(2)}
            variant="outlined"
            fullWidth
          />
          <TextField
            label="原価(月額)"
            value={formData[3] || ""}
            onChange={handleChange(3)}
            variant="outlined"
            fullWidth
          />
          <TextField
            label="売価(年額)"
            value={formData[4] || ""}
            onChange={handleChange(4)}
            variant="outlined"
            fullWidth
          />
          <TextField
            label="原価(年額)"
            value={formData[5] || ""}
            onChange={handleChange(5)}
            variant="outlined"
            fullWidth
          />
          <TextField
            label="業者"
            value={formData[6] || ""}
            onChange={handleChange(6)}
            variant="outlined"
            fullWidth
          />
          <TextField
            label="開始日"
            type="date"
            value={formData[7] || ""}
            onChange={handleChange(7)}
            variant="outlined"
            fullWidth
            InputLabelProps={{
              shrink: true,
            }}
          />
          <FormControl fullWidth>
            <InputLabel id="payment-label">業者からの支払日</InputLabel>
            <Select
              labelId="payment-label"
              value={formData[8] || ""}
              onChange={handleChange(8)}
            >
                {Option3.map((option)=><MenuItem value={option}>{option}</MenuItem>)}
            </Select>
          </FormControl>
          <TextField
            label="回数"
            type="number"
            value={formData[9] || ""}
            onChange={handleChange(9)}
            variant="outlined"
            fullWidth
          />
          <TextField
            label="スポット売価"
            value={formData[10] || ""}
            onChange={handleChange(10)}
            variant="outlined"
            fullWidth
          />
          <TextField
            label="スポット原価"
            value={formData[11] || ""}
            onChange={handleChange(11)}
            variant="outlined"
            fullWidth
          />
          <TextField
            label="第1回目"
            value={formData[12] || ""}
            onChange={handleChange(12)}
            variant="outlined"
            fullWidth
          />
          <TextField
            label="第2回目"
            value={formData[13] || ""}
            onChange={handleChange(13)}
            variant="outlined"
            fullWidth
          />
        </Box>
)}

function MinusNumberFormatCustom(props) {
    const { inputRef, onChange, ...other } = props;
    const [valueset, setValueset] = useState(0);
    console.log(props)
    return (
      <NumericFormat
        {...other}
        ref={inputRef}
        style={{ textAlign: 'right' }}
  
        onValueChange={values => {
  
          // console.log(values.value ? String(parseInt(values.value) * -1) : 0)
          setValueset(values.value)
          onChange({
            target: {
              value: values.value,
            },
          });
        }}
  
        thousandSeparator={true}
        // prefix={valueset > 0 ? '-' : ''}
      />
    );
  }

function NewApplicationIndex(props) {

    const { id } = useParams();
    /////////////////////////////////////

    const [completed, setCompleted] = useState(false);
    const [year_list, setYearList] = useState([""]);
    const [application_form_id, setApplicationFormId] = useState(0);
    const [application_id, setApplicationId] = useState(0);
    // const [application_detail, setApplicationDetail] = useState([]);
    const [form_title, setFormTitle] = useState([]);// 申請タイトル
    const [form_detail, setFormDetail] = useState([]);// 入力フォーム
    const [form_authorizer, setFormAuthorizer] = useState([]);
    const [detail, setDetail] = useState([]);
    const [userlist, setUserList] = useState([]);//ユーザーリスト
    const [training_event_list, setTrainingEventList] = useState([]);//研修リスト
    const [tatemono_list, setTatemonoList] = useState([]);//建物リスト
    const [room_list, setRoomList] = useState([]);//部屋リスト
    const [error, setError] = useState("");//エラーリスト

    // const token = authentication.getAccessToken();
    const authentication = useContext(Authentication)

    

    // 項目は何があるか取得
    const getFormDetail = async (application_form_id) => {
// alert(application_form_id)
        // const f = await fetch(`http://localhost:5000/v1/flw/form/adds/list/` + application_form_id, { method: 'get', headers: { 'Authorization': 'Bearer ' + authentication.getAccessToken(), 'Content-type': 'application/json; charset=UTF-8' } })
        const f = await fetch(process.env.REACT_APP_API_BASE_URL + `/v1/flw/form/adds/list/` + application_form_id, { method: 'get', headers: { 'Authorization': 'Bearer ' + authentication.getAccessToken(), 'Content-type': 'application/json; charset=UTF-8' } })
        const d = await f.json()
        setFormDetail(d.flw_form_adds.filter(a=>a.del_flg == 0))
        // setApplicationDetail(d.flw_forms)
        setFormTitle(d.flw_forms.form_name)
        // alert(d.length)
        getDefault(d.flw_form_adds.filter(a=>a.del_flg == 0))
        

    }
    // 承認者は誰か取得
    const getFormAuthorizer = async (application_form_id) => {
// alert(application_form_id)
        // const f = await fetch(`http://localhost:5000/v1/flw/forms/authorizer/` + application_form_id, { method: 'get', headers: { 'Authorization': 'Bearer ' + authentication.getAccessToken(), 'Content-type': 'application/json; charset=UTF-8' } })
        const f = await fetch(process.env.REACT_APP_API_BASE_URL + `/v1/flw/forms/authorizer/` + application_form_id, { method: 'get', headers: { 'Authorization': 'Bearer ' + authentication.getAccessToken(), 'Content-type': 'application/json; charset=UTF-8' } })
        const d = await f.json()
        setFormAuthorizer(d)

    }

    const getApplicationId = async (application_form_id) => {
        // alert("newapplicationid")
        let data = {
            form_id: application_form_id
        }
        // const f = await fetch(`http://localhost:5000/v1/flw/applications/newapplicationid`, { method: 'post', body: JSON.stringify(data), headers: { 'Authorization': 'Bearer ' + authentication.getAccessToken(), 'Content-type': 'application/json; charset=UTF-8' } })
        const f = await fetch(process.env.REACT_APP_API_BASE_URL + `/v1/flw/applications/newapplicationid`, { method: 'post', body: JSON.stringify(data), headers: { 'Authorization': 'Bearer ' + authentication.getAccessToken(), 'Content-type': 'application/json; charset=UTF-8' } })
        const d = await f.json()
        setApplicationId(d)
    }

    const insertApplication = async () => {
        let data = {
            form_id: application_form_id,
            application_id: application_id,
        }
        data["form_detail"] = form_detail
        data["title"] = form_title
        data["detail"] = detail

        // const f = await fetch(`http://localhost:5000/v1/flw/applications/insert`, { method: 'put', body: JSON.stringify(data), headers: { 'Authorization': 'Bearer ' + authentication.getAccessToken(), 'Content-type': 'application/json; charset=UTF-8' } })
        const f = await fetch(process.env.REACT_APP_API_BASE_URL + `/v1/flw/applications/insert`, { method: 'put', body: JSON.stringify(data), headers: { 'Authorization': 'Bearer ' + authentication.getAccessToken(), 'Content-type': 'application/json; charset=UTF-8' } })
        const d = await f.json()
        // setApplicationId(d)
    }

    const getTatemonoList = async (key, kbn, name) => {
        // alert(application_form_id)
        let data = {
            name: name,
        }
        let url = ""
        if(kbn == 1){// 建物
            // url = "http://localhost:5000/v1/tm/tatemono/searchname"
            url = process.env.REACT_APP_API_BASE_URL + "/v1/tm/tatemono/searchname"
        }else{// P
            // url = "http://localhost:5000/v1/tm/parking/searchname"
            url = process.env.REACT_APP_API_BASE_URL + "/v1/tm/parking/searchname"
        }
        
        const f = await fetch(url, { method: 'post', body: JSON.stringify(data), headers: { 'Authorization': 'Bearer ' + authentication.getAccessToken(), 'Content-type': 'application/json; charset=UTF-8' } })
        const d = await f.json()
        // console.log("tatemonolist", d)
        // setTatemonoList(d)
        setTatemonoList((prevDetail) => prevDetail.map((value, index) => (index === key ? d : value)));

    }

    const getRoomList = async (key, kbn, tatemono_id) => {
        // alert(application_form_id)
        let url = ""
        if(kbn == 1){// 建物
            // url = "http://localhost:5000/v1/tm/room/list"
            url = process.env.REACT_APP_API_BASE_URL + "/v1/tm/room/list"
        }else{// P
            // url = "http://localhost:5000/v1/tm/parkingarea/list"
            url = process.env.REACT_APP_API_BASE_URL + "/v1/tm/parkingarea/list"
        }

        let data = {
            tatemono_id: tatemono_id,
        }
        const f = await fetch(url, { method: 'post', body: JSON.stringify(data), headers: { 'Authorization': 'Bearer ' + authentication.getAccessToken(), 'Content-type': 'application/json; charset=UTF-8' } })
        const d = await f.json()
        console.log("toomlist", d)
        // setRoomList(d)
        setRoomList((prevDetail) => prevDetail.map((value, index) => (index === key ? d : value)));
    }

    const getTatemonoTantou = async (key, kbn, tatemono_id) => {
        // alert(application_form_id)
        let url = ""
        if(kbn == 1){// 建物
            // url = "http://localhost:5000/v1/search/rooms/roomlist"
            url = process.env.REACT_APP_API_BASE_URL + "/v1/search/rooms/roomlist"
        }else{// P
            return
        }

        let data = {
            tatemono_id: tatemono_id,
        }
        const f = await fetch(url, { method: 'post', body: JSON.stringify(data), headers: { 'Authorization': 'Bearer ' + authentication.getAccessToken(), 'Content-type': 'application/json; charset=UTF-8' } })
        const d = await f.json()
        console.log("roomslist", d)
        // setRoomList(d)
        if(d.length > 0){
            setDetail((prevDetail) =>
                prevDetail.map((value, index) => (index === key ? value.split(",").map((value2, index2) => (index2 === 2 ? d[0].Owner_Tantou_No : value2)).join(',') : value))
            );
        }
    }


    const getYearList = async () => {
        
        for (let i = 1900; i <= parseInt(moment().add(5, 'years').format("YYYY")); i++) {
            setYearList((oldValue => [...oldValue, i]))   // ←変更
            // setYearList([...year_list, i]);
        }
    }

    const getDefault = async (list) => {
        setDetail([])
        // alert(list.length)
        for (let i = 0; i < list.length; i++) {
            if(list[i].formitem_id == 9) {// 年月
                let tmp = []
                for(let j = 0; j <= 1; j++) { 
                    tmp.push("")
                }
                setDetail((oldValue => [...oldValue, tmp.join(',')]))
            } else if(list[i].formitem_id == 11) {// 物件
                let tmp = [1]
                for(let j = 0; j <= 1; j++) { 
                    tmp.push("")
                }
                setDetail((oldValue => [...oldValue, tmp.join(',')]))
            } else if(list[i].formitem_id == 14) {// 担当
                let tmp = [1]
                for(let j = 0; j <= 1; j++) { 
                    tmp.push("")
                }
                setDetail((oldValue => [...oldValue, tmp.join(',')]))
            } else { 
                setDetail((oldValue => [...oldValue, ""]))   // ←変更
            }
            
            setTatemonoList((oldValue => [...oldValue, ""]))
            setRoomList((oldValue => [...oldValue, ""]))
        }
    }
    
    const getUsersListData = async () => {
        // const f = await fetch(`http://localhost:5000/v1/users/list`, { method: 'get', headers: { 'Authorization': 'Bearer ' + authentication.getAccessToken(), 'Content-type': 'application/json; charset=UTF-8' } })
        const f = await fetch(process.env.REACT_APP_API_BASE_URL + `/v1/users/list`, { method: 'get', headers: { 'Authorization': 'Bearer ' + authentication.getAccessToken(), 'Content-type': 'application/json; charset=UTF-8' } })
        const d = await f.json()
        setUserList(d)
    }

    const getTrainingEventListData = async () => {
        // const f = await fetch(`http://localhost:5000/v1/training/events/list`, { method: 'get', headers: { 'Authorization': 'Bearer ' + authentication.getAccessToken(), 'Content-type': 'application/json; charset=UTF-8' } })
        const f = await fetch(process.env.REACT_APP_API_BASE_URL + `/v1/training/events/list`, { method: 'get', headers: { 'Authorization': 'Bearer ' + authentication.getAccessToken(), 'Content-type': 'application/json; charset=UTF-8' } })
        const d = await f.json()
        setTrainingEventList(d)
    }

    useEffect(() => {

        if(id > 0){
            // alert(application_id)
            setApplicationFormId(id)//form_idセット
            getFormDetail(id)//入力フォームリスト取得
            getFormAuthorizer(id)//承認ルート取得
            getApplicationId(id)//申請IDの取得   本番はここは有効にして。

            if(id == 42){// 研修
                getTrainingEventListData()
            }
        }

        getYearList()
        getUsersListData()

    }, [id])

    // 通常
    const onChangeDetail = (e, key) => {
        if(id == 42 && key == 0){
            setDetail((prevDetail) => prevDetail.map((value, index) => (index === key ? e : value)));
            setDetail((prevDetail) => prevDetail.map((value, index) => (index === key + 1 ? "" : value)));
        }else{
            setDetail((prevDetail) => prevDetail.map((value, index) => (index === key ? e : value)));
        }
        
    }
    // 日付
    const onChangeDetailDate = (e, key) => {
        setDetail((prevDetail) =>
            prevDetail.map((value, index) => (index === key ? moment(e).format("YYYY/MM/DD") : value))
        );
    }
    // 担当
    const onChangeDetailUser = (e, id, key) => {

        setDetail((prevDetail) =>
            prevDetail.map((value, index) => (index === key ? String(id) : value))
        );
    }
    
    // チェックボックス
    const onChangeDetailCheckbox = (e, key, choice_value, choice_key) => {
        if(e){
            setDetail((prevDetail) =>
                // prevDetail.map((value, index) => (index === key ? value.split(",").map((value2, index2) => (index2 === choice_key ? choice_value : value2)).join(',') : value))
                prevDetail.map((value, index) => (index === key ? value + (value ? "," : "") + choice_value : value))
            );
        } else {
            setDetail((prevDetail) =>
                // prevDetail.map((value, index) => (index === key ? value.split(",").map((value2, index2) => (index2 === choice_key ? "" : value2)).join(',') : value))
                prevDetail.map((value, index) => (index === key ? value.split(",").filter(value2 => value2 != choice_value).join(',') : value))
            );
        }
    }

    // 年月の年の部分
    const onChangeDetailNen = (e, key) => {
        setDetail((prevDetail) =>
            prevDetail.map((value, index) => (index === key ? value.split(",").map((value2, index2) => (index2 === 0 ? e : value2)).join(',') : value))
        );
    }
    // 年月の月の部分
    const onChangeDetailMonth = (e, key) => {
        setDetail((prevDetail) =>
            prevDetail.map((value, index) => (index === key ? value.split(",").map((value2, index2) => (index2 === 1 ? e : value2)).join(',') : value))
        );
    }

    // 建物の区分（建物orP）の部分
    const onChangeTatemonoKbn = (e, key, idx) => {
        setDetail((prevDetail) =>
            prevDetail.map((value, index) => (index === key ? value.split(",").map((value2, index2) => (index2 === idx ? e : value2)).join(',') : value))
        );
        //未選択に
        setDetail((prevDetail) =>
            prevDetail.map((value, index) => (index === key ? value.split(",").map((value2, index2) => (index2 === 1 || index2 === 2 ? "" : value2)).join(',') : value))
        );
        // リストを初期化
        setTatemonoList((prevDetail) => prevDetail.map((value, index) => (index === key ? [] : value)));
        setRoomList((prevDetail) => prevDetail.map((value, index) => (index === key ? [] : value)));
    }
    const onChangeTatemono = (e, id, key, idx, item_id) => {

        setDetail((prevDetail) =>
            prevDetail.map((value, index) => (index === key ? value.split(",").map((value2, index2) => (index2 === idx ? id : value2)).join(',') : value))
        );

        if(idx == 1){// 建物変更時
            setDetail((prevDetail) =>
                prevDetail.map((value, index) => (index === key ? value.split(",").map((value2, index2) => (index2 === 2 ? "" : value2)).join(',') : value))
            );
            if(id > 0){ // 建物IDがあったら部屋リスト取得
                //部屋リスト取得
                getRoomList(key, detail[key].split(',')[0], id)

                if(item_id == 14){
                    //物件担当を取得
                    getTatemonoTantou(key, detail[key].split(',')[0], id)
                }
                
            }
        }
    }

    let timer
    const onChangeTatemonoList = (e, key) => {
        if (e.target.value) {
            let name = e.target.value
            let kbn = detail[key].split(',')[0]
            clearTimeout(timer);
            timer = setTimeout(() => {
                getTatemonoList(key, kbn, name)
            }, 400);
        }
    }

    const onClickApplication = () => {
        // alert("更新")

        let str = []
        if(application_form_id != 11 && application_form_id != 33 && form_title == ""){
            str.push("タイトルが入力されていません。")
        }
        for(let i=0; i<form_detail.length; i++){
            if(form_detail[i].required){
                if(form_detail[i].formitem_id === 11 || detail[i].formitem_id === 14 || detail[i].formitem_id === 9){//物件//担当//年月
                    if(detail[i].split(',')[0] == "" || detail[i].split(',')[1] == "" || detail[i].split(',')[2] == ""){
                        str.push(form_detail[i].formitem_name +"が入力されていません。")
                    }
                }else{
                    if(detail[i] == ""){
                        str.push(form_detail[i].formitem_name +"が入力されていません。")
                    }
                }
            }
        } 

        setError(str)

        if(application_id > 0){
            if(str.length == 0){
                setCompleted(true)
                insertApplication()//申請
            }else{
                // alert(str)
            }
        }else{
            alert("err")
        }
    }
//プレシャスタイム
    return (
        
        <div style={{paddingTop:'54px', paddingLeft:64}}>
            {/* {JSON.stringify(detail)}
            {JSON.stringify(tatemono_list)}
            {application_id} */}
{/* {JSON.stringify(tatemono_list)} */}
            {completed ? 
            <div style={{padding: 20, height: 300, width: "100%", position: "relative"}}>
                <span style={{backgroundColor: "white", border:"1px solid #c4c4c4", position: "absolute", top: "50%", left: "50%", transform: "translateY(-50%) translateX(-50%)", padding: "50px 100px"}}>申請しました</span>
            </div> : 
            <>
            {/* <div style={{backgroundColor:"white", margin:10, padding:10, border:"1px solid #c4c4c4"}}> */}
            <Card style={{margin:10, padding:10}}>
                <LocalizationProvider dateAdapter={AdapterDateFns} locale={ja}>
                <table className='flw_new_table'>
                    <tr>
                        {/* <th>
                            申請タイトル
                            {application_form_id != 11 && application_form_id != 33 ? <span className='required'>必須</span> : ""}
                        </th> */}
                        <td style={{padding:10}}>
                            <TextField 
                                label={"申請タイトル"}
                                style={{width:500}} 
                                value={form_title} 
                                size="small" 
                                // placeholder={value.remarks}
                                error={application_form_id != 11 && application_form_id != 33 && form_title == ""}
                                required={application_form_id != 11 && application_form_id != 33}
                                onChange={(e)=> {setFormTitle(e.target.value)}}
                                />
                        </td>
                    </tr>
                    {
                    form_detail.map(function (value, key) {
                        return <tr>
                            {/* <th>
                                {value.formitem_name}
                                {value.required ? <span className='required'>必須</span> : ""}
                            </th> */}
                            <td style={{padding:10}}>
                                {(() => {
                                    if (value.formitem_id === 1) {// テキスト
                                        return <TextField 
                                            label={value.formitem_name}
                                            style={{width:value.form_size ? value.form_size : 300}} 
                                            value={detail[key]} 
                                            size="small" 
                                            placeholder={value.remarks}
                                            required={value.required ? true : false}
                                            error={value.required && detail[key]==""}
                                            onChange={(e) => onChangeDetail(e.target.value, key)} />
                                    } else if (value.formitem_id === 2) {// 複数行
                                        return <TextField 
                                            label={value.formitem_name}
                                            style={{width:value.form_size ? value.form_size*10 : 300}} 
                                            multiline 
                                            maxRows={4} 
                                            value={detail[key]} 
                                            placeholder={value.remarks}
                                            required={value.required ? true : false}
                                            error={value.required && detail[key]==""}
                                            onChange={(e) => onChangeDetail(e.target.value, key)} 
                                            />
                                    } else if (value.formitem_id === 3) {// 数字
                                        return <TextField
                                            label={value.formitem_name}
                                            style={{width:value.form_size ? value.form_size : 300}} 
                                            placeholder={value.remarks}
                                            value={detail[key]}
                                            InputProps={{
                                                inputComponent: MinusNumberFormatCustom,
                                                endAdornment: <InputAdornment position="end">{value.remarks2}</InputAdornment>,
                                            }}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                            required={value.required ? true : false}
                                            error={value.required && detail[key]==""}
                                            onChange={(e) => onChangeDetail(e.target.value, key)}
                                            size="small"
                                        />
                                    } else if (value.formitem_id === 4) {// 日付
                                        return <DatePicker
                                                // label="最終承認日　開始"
                                                label={value.formitem_name}
                                                name="approval_start_date"
                                                value={detail[key] != "" ? detail[key] : null}
                                                onChange={(e) => onChangeDetailDate(e, key)}
                                                renderInput={(params) => <TextField size="small"
                                                required={value.required ? true : false}
                                                error={value.required && (detail[key]=='' || detail[key]==null)}
                                                {...params} sx={{ mr: 1 }} />}
                                            />
                                    } else if (value.formitem_id === 5) {// 月選択
                                        return <FormControl size='small'>
                                                <InputLabel id="demo-simple-select-label" required={value.required ? true : false}>{value.formitem_name}</InputLabel>
                                                <Select
                                                    label={value.formitem_name}
                                                    labelId="demo-simple-select-label"
                                                    id="demo-simple-select"
                                                    value={detail[key]}
                                                    onChange={(e) => onChangeDetail(e.target.value, key)}
                                                    style={{width:200}}
                                                    error={value.required && (detail[key]=='' || detail[key]==null)}
                                                >
                                                    <MenuItem value={""}></MenuItem>
                                                    {[1,2,3,4,5,6,7,8,9,10,11,12].map(function (choice_value, choice_key) {
                                                        return <MenuItem value={choice_value}>{choice_value + "月"}</MenuItem>
                                                    })}
                                                </Select>
                                            </FormControl>
                                    } else if (value.formitem_id === 6) {// ラジオボタン
                                        return <>
                                        <FormLabel component="legend" style={{ marginBottom: 0, fontSize: 14 }} required={value.required ? true : false}>{value.formitem_name}</FormLabel>
                                        <RadioGroup row aria-label="position" name="color" 
                                        onChange={(e) => onChangeDetail(e.target.value, key)}
                                        value={detail[key]}
                                        >
                                                {value.choice.split(',').map(function (choice_value, choice_key) {
                                                    return <FormControlLabel control={<Radio style={{backgroundColor: value.required && detail[key] == "" ? "#fdece9": "transparent"}} value={choice_value} />} label={choice_value} />
                                                })}
                                            </RadioGroup>
                                        </>
                                    } else if (value.formitem_id === 7) {// プルダウン
                                        if(id == 42 && value.formitem_name == "研修名選択"){
                                            return <FormControl size='small'>
                                                <InputLabel id="demo-simple-select-label" required={value.required ? true : false}>{value.formitem_name}</InputLabel>
                                                <Select
                                                    label={value.formitem_name}
                                                    labelId="demo-simple-select-label"
                                                    id="demo-simple-select"
                                                    value={detail[key]}
                                                    onChange={(e) => onChangeDetail(e.target.value, key)}
                                                    style={{width:value.form_size ? value.form_size* 4 : 300}} 
                                                    error={value.required && (detail[key]=='' || detail[key]==null)}
                                                >
                                                    <MenuItem value={""}></MenuItem>
                                                    {training_event_list.filter(a=>a.training_division == (detail[0] == "社外研修" ? 2 : detail[0] == "通信講座" ? 3 : 0)).map(function (choice_value, choice_key) {
                                                        return <MenuItem value={choice_value.training_event_id}>{choice_value.title}{(detail[0] == "社外研修" ? 2 : detail[0] == "通信講座" ? "("+moment(choice_value.training_day).format("YYYY/MM/DD")+")" : 0)}</MenuItem>
                                                    })}
                                                </Select>
                                            </FormControl>
                                        }else{
                                            return <FormControl size='small'>
                                                <InputLabel id="demo-simple-select-label" required={value.required ? true : false}>{value.formitem_name}</InputLabel>
                                                <Select
                                                    labelId="demo-simple-select-label"
                                                    id="demo-simple-select"
                                                    value={detail[key]}
                                                    onChange={(e) => onChangeDetail(e.target.value, key)}
                                                    style={{width:value.form_size ? value.form_size* 4 : 300}} 
                                                    error={value.required && (detail[key]=='' || detail[key]==null)}
                                                >
                                                    <MenuItem value={""}></MenuItem>
                                                    {value.choice.split(',').map(function (choice_value, choice_key) {
                                                        return <MenuItem value={choice_value}>{choice_value}</MenuItem>
                                                    })}
                                                </Select>
                                            </FormControl>
                                        }
                                        
                                    } else if (value.formitem_id === 8) {// チェックボックス
                                        return <>
                                            <FormLabel component="legend" style={{ marginBottom: 0, fontSize: 14 }} required={value.required ? true : false}>{value.formitem_name}</FormLabel>
                                            {value.choice.split(',').map(function (choice_value, choice_key) {
                                                return <FormControlLabel control={<Checkbox style={{backgroundColor: value.required && detail[key] == "" ? "#fdece9": "transparent"}} checked={detail[key].split(',').includes(choice_value)} onChange={(e) => onChangeDetailCheckbox(e.target.checked, key, choice_value, choice_key)} />} label={choice_value} />
                                            })}
                                      </>
                                    } else if (value.formitem_id === 9) {// 年月選択
                                        return <div style={{display: "flex"}}>
                                            <FormControl size='small' >
                                            <InputLabel id="demo-simple-select-label" required={value.required ? true : false}>{value.formitem_name}</InputLabel>
                                            
                                            <Select
                                                label={value.formitem_name}
                                                labelId="demo-simple-select-label"
                                                id="demo-simple-select"
                                                value={detail[key].split(",")[0]}
                                                onChange={(e) => onChangeDetailNen(e.target.value, key)}
                                                style={{width:200}}
                                                error={value.required && detail[key].split(",")[0]==''}
                                            >
                                                {year_list.map(function (choice_value, choice_key) {
                                                    return <MenuItem value={choice_value}>{choice_value}</MenuItem>
                                                })}
                                            </Select>
                                            </FormControl>年
                                            <FormControl size='small' >
                                                <Select
                                                    labelId="demo-simple-select-label"
                                                    id="demo-simple-select"
                                                    value={detail[key].split(",")[1]}
                                                    onChange={(e) => onChangeDetailMonth(e.target.value, key)}
                                                    style={{width:100}}
                                                    error={value.required && detail[key].split(",")[1]==''}
                                                >
                                                    <MenuItem value={""}></MenuItem>
                                                    {[1,2,3,4,5,6,7,8,9,10,11,12].map(function (choice_value, choice_key) {
                                                        return <MenuItem value={choice_value}>{choice_value + "月"}</MenuItem>
                                                    })}
                                                </Select>
                                                </FormControl>日
                                            </div>
                                    } else if (value.formitem_id === 10) {// 時刻
                                        return <span>未対応</span>
                                    } else if (value.formitem_id === 11) {// 物件
                                        return <>
                                            <FormLabel required={value.required ? true : false} component="legend" style={{ marginBottom: 0, fontSize: 14 }}>{value.formitem_name}</FormLabel>
                                            
                                            <RadioGroup row aria-label="position" name="color" 
                                                onChange={(e) => onChangeTatemonoKbn(e.target.value, key, 0)}
                                                value={detail[key].split(',')[0]}
                                            >
                                                <FormControlLabel control={<Radio value={1} />} label={"物件"} />
                                                <FormControlLabel control={<Radio value={2} />} label={"駐車場"} />
                                            </RadioGroup>
                                            <div style={{display: "flex"}}>
                                            <Autocomplete
                                                id="tatemono_id"
                                                options={tatemono_list[key] == "" ? [] : tatemono_list[key]}
                                                getOptionLabel={(option) => option.tatemono_name ? option.tatemono_name : ''}
                                                style={{ width: 300 }}
                                                name="tatemono_id"
                                                value={detail[key].split(',')[1] == "" ? {tatemono_id:"", tatemono_name:""} : tatemono_list[key].length > 0 ? tatemono_list[key].filter(a => a.tatemono_id === detail[key].split(',')[1])[0]:{tatemono_id:"", tatemono_name:""}}
                                                onChange={(e, newValue) => onChangeTatemono(e, newValue && newValue.tatemono_id ? newValue.tatemono_id : "", key, 1, value.formitem_id)}
                                                renderInput={(params) => <TextField
                                                {...params}
                                                variant="outlined"
                                                size="small"
                                                error={value.required && detail[key].split(",")[1]==''}
                                                InputProps={{
                                                    ...params.InputProps,
                                                    endAdornment: (
                                                    <React.Fragment>

                                                        {params.InputProps.endAdornment}
                                                    </React.Fragment>
                                                    ),
                                                }}
                                                onChange={(e)=>onChangeTatemonoList(e, key)}
                                                label={"物件名"} />}

                                            />
                                            <Autocomplete
                                                size="small"
                                                options={room_list[key] == "" ? [] : room_list[key]}
                                                getOptionLabel={(option) => option.room_name}
                                                value={detail[key].split(',')[2] == "" ? {room_id:"", room_name:""} : room_list[key].filter(a => a.room_id === detail[key].split(',')[2])[0]}
                                                style={{ width: 200 }}
                                                onChange={(e, newValue) => onChangeTatemono(e, newValue && newValue.room_id ? newValue.room_id : "", key, 2, value.formitem_id)}
                                                renderInput={(params) => <TextField 
                                                    error={value.required && (detail[key].split(",")[2]=='')}
                                                    {...params} label={"部屋名"} />}

                                            />
                                            </div>
                                        </>

                                    } else if (value.formitem_id === 12) {// 添付ファイル 

                                        return <span>未対応</span>
                                    } else if (value.formitem_id === 13) {// エリア店長用
                                        return <><Autocomplete
                                            fullWidth
                                            size="small"
                                            options={userlist}
                                            getOptionLabel={(option) => option.user_name_all}
                                            value={detail[key] == "" ? {id:"",user_name_all:""} : userlist.filter(a => String(a.id) === String(detail[key]))[0]}
                                            style={{ width: 200 }}
                                            onChange={(e, newValue) => onChangeDetailUser(e, newValue && newValue.id ? newValue.id : "", key)}
                 
                                            renderInput={(params) => <TextField label={value.formitem_name} 
                                            required={value.required ? true : false}
                                            error={value.required && (detail[key]=='')}
                                                {...params} />}

                                        /></>
                                    } else if (value.formitem_id === 14) {// 物件部屋担当セットのやつ
                                        return <>
                                            <FormLabel component="legend" required={value.required ? true : false} style={{ marginBottom: 0, fontSize: 14 }}>{value.formitem_name}</FormLabel>
                                            <RadioGroup row aria-label="position" name="color" 
                                                onChange={(e) => onChangeTatemonoKbn(e.target.value, key, 0)}
                                                value={detail[key].split(',')[0]}
                                            >
                                                <FormControlLabel control={<Radio value={1} />} label={"物件"} />
                                                <FormControlLabel control={<Radio value={2} />} label={"駐車場"} />
                                            </RadioGroup>
                                            <div style={{display: "flex"}}>
                                            <Autocomplete
                                                id="tatemono_id"
                                                options={tatemono_list[key] == "" ? [] : tatemono_list[key]}
                                                getOptionLabel={(option) => option.tatemono_name ? option.tatemono_name : ''}
                                                style={{ width: 300 }}
                                                name="tatemono_id"
                                                value={detail[key].split(',')[1] == "" ? {tatemono_id:"", tatemono_name:""} : tatemono_list[key].length > 0 ? tatemono_list[key].filter(a => a.tatemono_id === detail[key].split(',')[1])[0]:{tatemono_id:"", tatemono_name:""}}
                                                onChange={(e, newValue) => onChangeTatemono(e, newValue && newValue.tatemono_id ? newValue.tatemono_id : "", key, 1, value.formitem_id)}
                                                renderInput={(params) => <TextField
                                                {...params}
                                                variant="outlined"
                                                size="small"
                                                error={value.required && detail[key].split(",")[1]==''}
                                                InputProps={{
                                                    ...params.InputProps,
                                                    endAdornment: (
                                                    <React.Fragment>

                                                        {params.InputProps.endAdornment}
                                                    </React.Fragment>
                                                    ),
                                                }}
                                                onChange={(e)=>onChangeTatemonoList(e, key)}
                                                label={"物件名"} />}

                                            />
                                            
                                            <Autocomplete
                                                fullWidth
                                                size="small"
                                                options={userlist}
                                                getOptionLabel={(option) => option.user_name_all}
                                                value={detail[key].split(',')[2] != "" ? userlist.filter(a => String(a.id) == String(detail[key].split(',')[2]))[0] : null}
                                                style={{ width: 200 }}
                                                onChange={(e, newValue) => onChangeTatemono(e, newValue && newValue.id ? newValue.id : "", key, 2)}
                    
                                                renderInput={(params) => <TextField
                                                    error={value.required && detail[key].split(",")[2]==''}
                                                    {...params} label="担当" />}
                                            />
                                            </div>
                                        </>
                                    
                                }else if(value.formitem_id === 15) {// フォームを開く
                                    return <>
                                        <Accordion>
                                            <AccordionSummary
                                            aria-controls="panel1-content"
                                            id="panel1-header"
                                            >
                                            {value.formitem_name} フォームを開く
                                            </AccordionSummary>
                                            <AccordionDetails>
                                                <FormDetails changeDetail={(e) => onChangeDetail(e,key)} value={value}/>
                                            </AccordionDetails>
                                        </Accordion>
                                    </>}
                                })()}
                                {/* {value.formitem_name} */}
                            </td>
                        </tr>
                    })
                    }
                </table>
                </LocalizationProvider>
            {/* </div> */}
            </Card>
            <Card style={{margin:10, padding:10}}>

                <div style={{padding:20, textAlign:"left"}}>
                    <div style={{marginBottom:10}}>承認ルート</div>
                    {
                        form_authorizer.map(function (value, key) {

                            // return <TimelineItem>
                            //     <TimelineSeparator>
                            //     <TimelineDot color={ "primary"} style={{ opacity: 1}} />
                            //     {form_authorizer.length > key + 1 ? <TimelineConnector color={"secondary"} /> : ""}
                            //     </TimelineSeparator>
                            //     <TimelineContent>

                            //     {<Chip label={value.all_approval == 1 ? "誰か一人が承認" : "すべての承認が必要"} style={{ fontSize: 14,  opacity: 1}} variant="outlined" />}
                            //     {
                            //         value.authorizers.map(function (value2, key2) {// 0:未承認　1:承認　2:差し戻し　3:却下　4:再申請　5：申請者によるキャンセル
                            //             return <div style={{marginLeft:15, marginTop:3, fontSize:14, opacity:detail[0].status_path >= value.path_no ? 1 : 0.5}}>

                            //                 <span style={{marginLeft:5}}>{value.approval_type_name}者：{value2.user_name_all}</span>

                            //                 </div>
                            //         })
                            //     }

                            //     </TimelineContent>
                            // </TimelineItem>

                            return <div style={{display: "flex", marginBottom:10}}>
                                <div className='bango'>{key + 1}</div>
                                <div style={{marginLeft:40}}>
                                    {<Chip label={value.all_approval == 1 ? "誰か一人が承認" : "すべての承認が必要"} style={{ fontSize: 14,  opacity: 1}} variant="outlined" />}
                                    {
                                        value.authorizers.map(function (value2, key2) {// 0:未承認　1:承認　2:差し戻し　3:却下　4:再申請　5：申請者によるキャンセル
                                            return <div style={{marginLeft:15, marginTop:3, fontSize:14, opacity: 1, textAlign:"left"}}>

                                                <span style={{marginLeft:5}}>{value.approval_type_name}者：{value2.user_name_all}</span>

                                                </div>
                                        })
                                    }
                                </div>
                            </div>

                        })
                    }
                </div>














            </Card>
            {error.length > 0?
                <Alert severity="error" style={{textAlign:"left"}}>
                {/* <AlertTitle>未入力の項目があります。</AlertTitle> */}
                {
                    error.map(function (value, key) {
                        return <div>{value}</div>
                    })
                }
              </Alert>
                :""
            }
            <Button style={{marginBottom:20}} size="large" variant="contained" color="success" onClick={()=>onClickApplication()}>申請する</Button>
            </>}
        </div>
    );
}

export  default NewApplicationIndex;
